import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import data from './modules/data'
import router from './modules/router'

Vue.use(Vuex);
const getters = {
  token: state => state.user.userInfo ? state.user.userInfo.token : null,
  uid: state => state.user.userInfo ? state.user.userInfo.id : null,
  userInfo: state => state.user.userInfo ? state.user.userInfo : null,
  asideData: state => state.data.asideData ,//侧边栏数据
  direct: state => state.data.direct, //显示导航数据
  beforeRouterPath: state => state.router.beforeRouterPath,//上一模块路由路径
  permission: state => state.data.permission,//权限
}
export default new Vuex.Store({
  modules: {
    user,
    data,
    router,
  },
  getters,
})



// WEBPACK FOOTER //
// ./src/store/index.js